import React from 'react';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
import {getDateUtilDefaultInstance} from '/util/date.util';

import {styles} from './LicenseExpiresOn.style';

interface LicenseExpiresOnItem {
  licenseExpiresOn?: string | null;
}

interface LicenseExpiresOnProps {
  tt: (key: string, options?: object) => string;
  item: LicenseExpiresOnItem;
}

export const LicenseExpiresOn: React.FC<LicenseExpiresOnProps> = ({
  tt = withTranslation.ttDefaultProp,
  item = {},
}) => {
  const licenseExpiresOn = get(item, 'licenseExpiresOn', '');

  return tt(
    'expiresOn',
    generateComponentCallback({
      component: (
        <Text testID={Reports.reportLicenseExpiringOn}>
          <Text style={styles.expiryLabel}>License Expires </Text>{' '}
          {getDateUtilDefaultInstance().formatDate(
            licenseExpiresOn,
            'MMMM d, yyyy',
          )}
        </Text>
      ),
    }),
  );
};

export default withTranslation('report.record.licenseExpiresOn')(
  LicenseExpiresOn,
);
